export const sectionData = [
  {
    id: "about",
    displayText: "About Me",
    caption: "Who I am and what I do",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696098375/Portfolio%20App/About_me_mjxlxq.png",
  },
  {
    id: "work",
    displayText: "My Work",
    caption: "Projects I worked on",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696098251/Portfolio%20App/Notebook_fgk7bv.png",
  },
  {
    id: "techstack",
    displayText: "Tech Stack",
    caption: "The dev tools, apps, devices, and games I use and play.",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696098290/Portfolio%20App/Tech_Stack_rvoqou.png",
  },
  {
    id: "certificates",
    displayText: "My Certificates",
    caption: "Certified and Confident: Showcasing My Expertise",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696165647/Portfolio%20App/Bookshelf_lbpytj.png",
  },
];

export const recentProjectsData = [
  {
    id: "Eyesome App",
    title: "Eyesome App",
    description:
      "The Eyesome App stands as an unparalleled hub for all your eyewear desires, seamlessly merging the ease of online shopping with the realm of eyewear fashion. Offering a sophisticated and intuitive interface, the app caters to users seeking a hassle-free eyewear shopping experience. Once logged in, users are welcomed into a world of curated products, enhanced by powerful search, filtering, and sorting capabilities. The Eyesome App offers a curated eyewear experience with effortless add/remove to cart and wishlist functionality. Users can seamlessly review order summary, confirm the total, and choose from secure payment options like Cash on Delivery, credit/debit cards, or net banking. With these conveniences, users confidently finalize their orders, making eyewear shopping online a breeze",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696264905/Portfolio%20App/React-icon_1_mn4cui.png",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696273911/Portfolio%20App/eyesome_bs7zpu.png",
    projectLink: "https://omkeyesome.netlify.app",
    githubLink: "https://github.com/DEV-OMK/Eyesome",
  },
  {
    id: "NxtWatch App",
    title: "NxtWatch App",
    description:
      "The Nxt Watch App, a YouTube replica, ensures a seamless experience for logged-in users. Exclusive access is granted to authenticated users, featuring a curated selection of videos, including trending, gaming, and saved content. Users can effortlessly explore videos, diving into specific details. Moreover, users enjoy the flexibility of toggling between themes, choosing between the vibrant 'Light' or the elegant 'Dark' interface. Additionally, the app offers interactive features such as liking, disliking, commenting on videos, and the option to save favorite content for future viewing.",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696264905/Portfolio%20App/React-icon_1_mn4cui.png",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696273768/Portfolio%20App/nxtwatch_tfjolx.png",
    projectLink: "https://omknxtwatch.ccbp.tech",
    githubLink: "https://github.com/DEV-OMK/NxtWatchApp",
  },
  {
    id: "Jobby App",
    title: "Jobby App",
    description:
      "The Jobby App stands as a comprehensive haven for job seekers, providing a seamless and efficient online job search experience globally. With its user-friendly login system, authorized users gain access to a plethora of employment opportunities. The app boasts advanced search features, allowing users to refine their job hunt by title, salary range, and employment type, ensuring tailored job recommendations.",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696264905/Portfolio%20App/React-icon_1_mn4cui.png",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696273452/Portfolio%20App/jobby_ceme3d.png",
    projectLink: "https://omkjobbyapp.ccbp.tech",
    githubLink: "https://github.com/DEV-OMK/JobbyApp",
  },
  {
    id: "NxtTrendz App",
    title: "NxtTrendz App",
    description:
      "The Nxt Trendz, a robust ECommerce platform mirroring the user experience of industry giants like Amazon and Flipkart. This feature-rich application offers a seamless journey for users, enabling them to log in, explore an extensive array of products, and utilize advanced search, filtering, and sorting functionalities. Users can easily manage their selections with intuitive add/remove options in the cart. Additionally, the app provides a comprehensive order summary feature, ensuring users have a clear overview of their purchases before completing the transaction. Nxt Trendz delivers a user-friendly, efficient, and secure online shopping experience.",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696264905/Portfolio%20App/React-icon_1_mn4cui.png",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696273456/Portfolio%20App/nxttrendz_x1pz7v.png",
    projectLink: "https://omknxttrendz9.ccbp.tech",
    githubLink: "https://github.com/DEV-OMK/NxtTrendzApp",
  },
  {
    id: "InstaShare App",
    title: "InstaShare App",
    description:
      "The InstaShare App, an innovative and responsive streaming platform akin to Instagram Clone, offers a seamless experience. Authenticated users gain access to a curated collection of captivating stories and posts. With its intuitive search functionality, users can explore posts based on descriptive captions. Additionally, users can engage by liking or disliking posts and exploring personalized user-specific content.",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696264905/Portfolio%20App/React-icon_1_mn4cui.png",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696273457/Portfolio%20App/instashare_fhgq79.png",
    projectLink: "https://omkinstashare.ccbp.tech",
    githubLink: "https://github.com/DEV-OMK/InstaShare",
  },
  {
    id: "CCBP Timeline App",
    title: "CCBP Timeline App",
    description:
      "Introducing CCBP Timeline, my interactive companion on the transformative journey through the NxtWave CCBP Intensive Certification Course. Dive into a curated chronicle that navigates the course's milestones, taking you through each step of my learning expedition. Experience the evolution of my skills, from the beginning to mastery, with this engaging and informative app. Embark on an enlightening exploration of my educational timeline, shaping my path towards excellence.",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696264905/Portfolio%20App/React-icon_1_mn4cui.png",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696275569/Portfolio%20App/timeline_mixftp.png",
    projectLink: "https://omkccbptimeline.ccbp.tech",
    githubLink: "https://github.com/DEV-OMK/CCBPTimeline",
  },
];

export const otherProjectsData1 = [
  {
    id: "NxtSlides App",
    title: "NxtSlides App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593779/Portfolio%20App/Screenshot_18_v3oqyp.png",
    projectLink: "https://omknxtslides.ccbp.tech",
    githubLink: "",
  },
  {
    id: "Projects App",
    title: "Projects App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593784/Portfolio%20App/Screenshot_21_vce8de.png",
    projectLink: "https://omkprojects.ccbp.tech",
    githubLink: "",
  },
  {
    id: "RockPaperScissor App",
    title: "RockPaperScissor App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593784/Portfolio%20App/Screenshot_31_yxgcax.png",
    projectLink: "https://omkrockpaper.ccbp.tech",
    githubLink: "",
  },
  {
    id: "GradientGenerator App",
    title: "GradientGenerator App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593784/Portfolio%20App/Screenshot_32_mdxjhq.png",
    projectLink: "https://omkgradientgen.ccbp.tech",
    githubLink: "",
  },
  {
    id: "CowinDashboard App",
    title: "CowinDashboard App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593788/Portfolio%20App/Screenshot_40_k1jitj.png",
    projectLink: "https://omkcowindash.ccbp.tech",
    githubLink: "",
  },
  {
    id: "GithubRepository App",
    title: "GithubRepository App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593786/Portfolio%20App/Screenshot_42_laso5l.png",
    projectLink: "https://omkgithubrepo.ccbp.tech",
    githubLink: "",
  },
  {
    id: "EmojiGame App",
    title: "EmojiGame App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593817/Portfolio%20App/Screenshot_57_xuwhiu.png",
    projectLink: "https://omkemojigame.ccbp.tech",
    githubLink: "",
  },
  {
    id: "AppStore App",
    title: "AppStore App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593817/Portfolio%20App/Screenshot_63_dfoo5o.png",
    projectLink: "https://omkappstore.ccbp.tech",
    githubLink: "",
  },
  {
    id: "Todos App",
    title: "Todos App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593829/Portfolio%20App/Screenshot_86_nl820t.png",
    projectLink: "https://omktodosapp.ccbp.tech",
    githubLink: "",
  },
  {
    id: "FoodMunch App",
    title: "FoodMunch App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593835/Portfolio%20App/Screenshot_87_bfstbk.png",
    projectLink: "https://omkfoodmunch.ccbp.tech",
    githubLink: "",
  },
];

export const otherProjectsData2 = [
  {
    id: "BMI Calculator",
    title: "BMI Calculator",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593778/Portfolio%20App/Screenshot_16_wtuwok.png",
    projectLink: "https://omkbmical.ccbp.tech",
    githubLink: "",
  },
  {
    id: "Notes App",
    title: "Notes App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593777/Portfolio%20App/Screenshot_17_vqmuxw.png",
    projectLink: "https://omknotesapp.ccbp.tech",
    githubLink: "",
  },

  {
    id: "MeetUp App",
    title: "MeetUp App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593779/Portfolio%20App/Screenshot_19_fddy8x.png",
    projectLink: "https://omkmeetup.ccbp.tech",
    githubLink: "",
  },
  {
    id: "TextEditor App",
    title: "TextEditor App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593779/Portfolio%20App/Screenshot_20_xh0npi.png",
    projectLink: "https://omktexteditor.ccbp.tech",
    githubLink: "",
  },

  {
    id: "EBank App",
    title: "EBank App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593780/Portfolio%20App/Screenshot_22_q5njhm.png",
    projectLink: "https://omkebank.ccbp.tech",
    githubLink: "",
  },
  {
    id: "TechEra App",
    title: "TechEra App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593780/Portfolio%20App/Screenshot_23_stmoho.png",
    projectLink: "https://omktechera.ccbp.tech",
    githubLink: "",
  },
  {
    id: "TravelGuide App",
    title: "TravelGuide App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593781/Portfolio%20App/Screenshot_24_obxbfr.png",
    projectLink: "https://omktravelguide.ccbp.tech",
    githubLink: "",
  },

  {
    id: "MyTask App",
    title: "MyTask App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593778/Portfolio%20App/Screenshot_25_qccekq.png",
    projectLink: "https://omkmytasks.ccbp.tech",
    githubLink: "",
  },
  {
    id: "VisitCountry App",
    title: "VisitCountry App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593779/Portfolio%20App/Screenshot_26_ly1e3t.png",
    projectLink: "https://omkvisitcountry.ccbp.tech",
    githubLink: "",
  },
  {
    id: "CharacterCount App",
    title: "CharacterCount App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593779/Portfolio%20App/Screenshot_27_tabxni.png",
    projectLink: "https://omkcharcounter.ccbp.tech",
    githubLink: "",
  },
  {
    id: "Music App",
    title: "Music App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593784/Portfolio%20App/Screenshot_28_izkwwf.png",
    projectLink: "https://omkmusic.ccbp.tech",
    githubLink: "",
  },
  {
    id: "Greeting App",
    title: "Greeting App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593781/Portfolio%20App/Screenshot_29_pdz6f6.png",
    projectLink: "https://omkgreeting.ccbp.tech",
    githubLink: "",
  },
  {
    id: "EditInput App",
    title: "EditInput App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593783/Portfolio%20App/Screenshot_30_lefd41.png",
    projectLink: "https://omkeditinput.ccbp.tech",
    githubLink: "",
  },
  {
    id: "MemeGenerator App",
    title: "MemeGenerator App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593784/Portfolio%20App/Screenshot_33_zfjocv.png",
    projectLink: "https://omkmemegen.ccbp.tech",
    githubLink: "",
  },
  {
    id: "NavbarTheme App",
    title: "NavbarTheme App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593785/Portfolio%20App/Screenshot_34_teoixl.png",
    projectLink: "https://omknavbartheme.ccbp.tech",
    githubLink: "",
  },
  {
    id: "LayoutBuilder App",
    title: "LayoutBuilder App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593784/Portfolio%20App/Screenshot_35_tvbrww.png",
    projectLink: "https://omklayoutbuild.ccbp.tech",
    githubLink: "",
  },
  {
    id: "ReactContext App",
    title: "ReactContext App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593785/Portfolio%20App/Screenshot_36_ge8jgd.png",
    projectLink: "https://omkreactcontext.ccbp.tech",
    githubLink: "",
  },

  {
    id: "PrimeVideo App",
    title: "PrimeVideo App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593786/Portfolio%20App/Screenshot_37_cfa1i1.png",
    projectLink: "https://omkprimevideo.ccbp.tech",
    githubLink: "",
  },

  {
    id: "HamburgerMenu App",
    title: "HamburgerMenu App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593785/Portfolio%20App/Screenshot_38_umww5f.png",
    projectLink: "https://omkhamburger.ccbp.tech",
    githubLink: "",
  },
  {
    id: "Planets App",
    title: "Planets App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593792/Portfolio%20App/Screenshot_39_cxqkql.png",
    projectLink: "https://omkplanetsapp.ccbp.tech",
    githubLink: "",
  },
  {
    id: "AlertNotification App",
    title: "AlertNotification App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593786/Portfolio%20App/Screenshot_41_vkzdvo.png",
    projectLink: "https://omkalertnotif.ccbp.tech",
    githubLink: "",
  },

  {
    id: "Events App",
    title: "Events App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593788/Portfolio%20App/Screenshot_43_fsyhjc.png",
    projectLink: "https://omkeventsapp.ccbp.tech",
    githubLink: "",
  },
  {
    id: "RegisterForm App",
    title: "RegisterForm App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593788/Portfolio%20App/Screenshot_44_qq1zhf.png",
    projectLink: "https://omkregisterform.ccbp.tech",
    githubLink: "",
  },
  {
    id: "IPLDashboard App",
    title: "IPLDashboard App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593792/Portfolio%20App/Screenshot_45_dyncib.png",
    projectLink: "https://omkdipldash.ccbp.tech",
    githubLink: "",
  },
  {
    id: "DeveloperBlog App",
    title: "DeveloperBlog App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593793/Portfolio%20App/Screenshot_46_e7s2to.png",
    projectLink: "https://omkddevblog.ccbp.tech",
    githubLink: "",
  },
  {
    id: "StopWatch App",
    title: "StopWatch App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593792/Portfolio%20App/Screenshot_47_hexsfh.png",
    projectLink: "https://omkdstopwatch.ccbp.tech",
    githubLink: "",
  },
  {
    id: "CryptoTracker App",
    title: "CryptoTracker App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593797/Portfolio%20App/Screenshot_48_elfuf9.png",
    projectLink: "https://omkcryptracker.ccbp.tech",
    githubLink: "",
  },
  {
    id: "MatchGame App",
    title: "MatchGame App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593809/Portfolio%20App/Screenshot_49_totpet.png",
    projectLink: "https://omkmatchgame.ccbp.tech",
    githubLink: "",
  },
  {
    id: "BlogSample App",
    title: "BlogSample App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593808/Portfolio%20App/Screenshot_51_xxlgmj.png",
    projectLink: "https://omkblogsample.ccbp.tech",
    githubLink: "",
  },

  {
    id: "PasswordManager App",
    title: "PasswordManager App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593800/Portfolio%20App/Screenshot_52_ci9kak.png",
    projectLink: "https://omkpasswordmgr.ccbp.tech",
    githubLink: "",
  },
  {
    id: "FAQ's App",
    title: "FAQ's App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593811/Portfolio%20App/Screenshot_53_pwa9og.png",
    projectLink: "https://omkfaqsapp.ccbp.tech",
    githubLink: "",
  },
  {
    id: "DigitalTimer App",
    title: "DigitalTimer App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593801/Portfolio%20App/Screenshot_54_h4ucow.png",
    projectLink: "https://omkdigitaltimer.ccbp.tech",
    githubLink: "",
  },
  {
    id: "Clock App",
    title: "Clock App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593807/Portfolio%20App/Screenshot_56_fhupbv.png",
    projectLink: "https://omkclockapp.ccbp.tech",
    githubLink: "",
  },

  {
    id: "MoneyManager App",
    title: "MoneyManager App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593808/Portfolio%20App/Screenshot_58_xqtdn9.png",
    projectLink: "https://omkmoneymgr.ccbp.tech",
    githubLink: "",
  },
  {
    id: "Comments App",
    title: "Comments App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593810/Portfolio%20App/Screenshot_59_e9gt43.png",
    projectLink: "https://omkcommentsapp.ccbp.tech",
    githubLink: "",
  },
  {
    id: "Contact App",
    title: "Contact App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593812/Portfolio%20App/Screenshot_60_pq4pyr.png",
    projectLink: "https://omkcontactapp.ccbp.tech",
    githubLink: "",
  },
  {
    id: "Review App",
    title: "Review App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593819/Portfolio%20App/Screenshot_61_cwfski.png",
    projectLink: "https://omkreviewsapp.ccbp.tech",
    githubLink: "",
  },
  {
    id: "CoinTossGame App",
    title: "CoinTossGame App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593817/Portfolio%20App/Screenshot_62_isnyzq.png",
    projectLink: "https://omkcointossgame.ccbp.tech",
    githubLink: "",
  },
  {
    id: "Capitals App",
    title: "Capitals App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593818/Portfolio%20App/Screenshot_64_pnjrhl.png",
    projectLink: "https://omkcapitalsapp.ccbp.tech",
    githubLink: "",
  },
  {
    id: "Gallery App",
    title: "Gallery App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593822/Portfolio%20App/Screenshot_65_lh5kqj.png",
    projectLink: "https://omkgalleryapp.ccbp.tech",
    githubLink: "",
  },
  {
    id: "Project App",
    title: "Project App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593821/Portfolio%20App/Screenshot_66_dlnp99.png",
    projectLink: "https://omkprojectapp.ccbp.tech",
    githubLink: "",
  },
  {
    id: "Feedback App",
    title: "Feedback App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593821/Portfolio%20App/Screenshot_67_xg6eth.png",
    projectLink: "https://omkfeedbackapp.ccbp.tech",
    githubLink: "",
  },
  {
    id: "BrowserHistory App",
    title: "BrowserHistory App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593821/Portfolio%20App/Screenshot_68_nbg5d3.png",
    projectLink: "https://omkbrowserhist.ccbp.tech",
    githubLink: "",
  },
  {
    id: "LetterCalculator App",
    title: "LetterCalculator App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593825/Portfolio%20App/Screenshot_69_lvwtow.png",
    projectLink: "https://omklettercalci.ccbp.tech",
    githubLink: "",
  },
  {
    id: "GoogleSearch App",
    title: "GoogleSearch App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593823/Portfolio%20App/Screenshot_70_ljtqqo.png",
    projectLink: "https://omkgooglesearch.ccbp.tech",
    githubLink: "",
  },
  {
    id: "CashWithdraw App",
    title: "CashWithdraw App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593824/Portfolio%20App/Screenshot_71_tg3qee.png",
    projectLink: "https://omkcashwithdraw.ccbp.tech",
    githubLink: "",
  },
  {
    id: "SimpleTodos App",
    title: "SimpleTodos App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593824/Portfolio%20App/Screenshot_72_m60l8r.png",
    projectLink: "https://omksimpletodos.ccbp.tech",
    githubLink: "",
  },
  {
    id: "SearchDestination App",
    title: "SearchDestination App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593825/Portfolio%20App/Screenshot_73_m5otdx.png",
    projectLink: "https://omksearchdest.ccbp.tech",
    githubLink: "",
  },
  // {
  //   id: "RandomNumberGenerator App",
  //   title: "RandomNumberGenerator App",
  //   imageUrl:
  //     "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593826/Portfolio%20App/Screenshot_74_oq9esb.png",
  //   projectLink: "https://omkrandomnogen.ccbp.tech",
  //   githubLink: "",
  // },
  {
    id: "SearchUser App",
    title: "SearchUser App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593826/Portfolio%20App/Screenshot_75_p1cxi4.png",
    projectLink: "https://omksearchuser.ccbp.tech",
    githubLink: "",
  },
  {
    id: "Login App",
    title: "Login App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593826/Portfolio%20App/Screenshot_76_kjux5f.png",
    projectLink: "https://omkloginapp.ccbp.tech",
    githubLink: "",
  },
  {
    id: "EvenOdd App",
    title: "EvenOdd App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593826/Portfolio%20App/Screenshot_77_z7z9qx.png",
    projectLink: "https://omkevenoddapp.ccbp.tech",
    githubLink: "",
  },
  {
    id: "ShowHide App",
    title: "ShowHide App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593827/Portfolio%20App/Screenshot_78_vlsolc.png",
    projectLink: "https://omkshowhide.ccbp.tech",
    githubLink: "",
  },
  {
    id: "DarkLightMode App",
    title: "DarkLightMode App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593827/Portfolio%20App/Screenshot_79_fhwykf.png",
    projectLink: "https://omkchangemode.ccbp.tech",
    githubLink: "",
  },
  {
    id: "Welcome App",
    title: "Welcome App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593827/Portfolio%20App/Screenshot_80_qwyxhy.png",
    projectLink: "https://omkwelcomeapp.ccbp.tech",
    githubLink: "",
  },
  {
    id: "FruitsCount App",
    title: "FruitsCount App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593828/Portfolio%20App/Screenshot_81_lct8y9.png",
    projectLink: "https://omkfrtcount.ccbp.tech",
    githubLink: "",
  },
  {
    id: "ClickCounter App",
    title: "ClickCounter App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593828/Portfolio%20App/Screenshot_82_nj0k4x.png",
    projectLink: "https://omkclickcounter.ccbp.tech",
    githubLink: "",
  },
  {
    id: "TechCard App",
    title: "TechCard App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593829/Portfolio%20App/Screenshot_83_vpcoum.png",
    projectLink: "https://omktechcard.ccbp.tech",
    githubLink: "",
  },
  {
    id: "Banner App",
    title: "Banner App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593829/Portfolio%20App/Screenshot_84_akbmqn.png",
    projectLink: "https://omkbanner.ccbp.tech",
    githubLink: "",
  },
  {
    id: "BookmarkMaker App",
    title: "BookmarkMaker App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593833/Portfolio%20App/Screenshot_88_ngvkky.png",
    projectLink: "https://omkbookmark.ccbp.tech",
    githubLink: "",
  },
  {
    id: "LibraryManagement App",
    title: "LibraryManagement App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593835/Portfolio%20App/Screenshot_89_yklhj4.png",
    projectLink: "https://omklibrary.ccbp.tech",
    githubLink: "",
  },
  {
    id: "AddUserForm App",
    title: "AddUserForm App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593835/Portfolio%20App/Screenshot_90_xzf58y.png",
    projectLink: "https://omkadduserform.ccbp.tech",
    githubLink: "",
  },
  {
    id: "SearchCountry App",
    title: "SearchCountry App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593835/Portfolio%20App/Screenshot_91_sniehp.png",
    projectLink: "https://omksearch.ccbp.tech",
    githubLink: "",
  },
  {
    id: "GuessTheNumber App",
    title: "GuessTheNumber App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593835/Portfolio%20App/Screenshot_92_lqe96m.png",
    projectLink: "https://omkguessnumber.ccbp.tech",
    githubLink: "",
  },
  {
    id: "WikipediaSearch App",
    title: "WikipediaSearch App",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696593839/Portfolio%20App/Screenshot_93_jkf6kh.png",
    projectLink: "https://omkwikipedia.ccbp.tech",
    githubLink: "",
  },
];

export const developerTools = [
  {
    id: "Figma",
    title: "Figma",
    tag: "Design",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696350741/Portfolio%20App/image_15_frg9uk.png",
  },
  {
    id: "Next.js",
    title: "Next.js",
    tag: "Web Framework",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696351187/Portfolio%20App/Nextjs_nhc7jc.png",
  },
  {
    id: "TailwindCSS",
    title: "TailwindCSS",
    tag: "CSS",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696353397/Portfolio%20App/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8_1_iqcj93.png",
  },
  {
    id: "Github",
    title: "Github",
    tag: "Version Control",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696353483/Portfolio%20App/image_2_edx6iu.png",
  },
  {
    id: "Vercel",
    title: "Vercel",
    tag: "Deployment",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696353598/Portfolio%20App/Vercel_oufpog.png",
  },
  {
    id: "VSCode",
    title: "VSCode",
    tag: "Editor",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696353722/Portfolio%20App/image_17_vliafs.png",
  },
  {
    id: "TypeScript",
    title: "TypeScript",
    tag: "Language",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696353759/Portfolio%20App/ts-logo-256_1_nckmot.png",
  },
  {
    id: "React Hook Form",
    title: "React Hook Form",
    tag: "Library",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696353815/Portfolio%20App/image_2_kqylj0.png",
  },
  {
    id: "React Query",
    title: "React Query",
    tag: "Server State",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696353841/Portfolio%20App/image_19_a8t7ja.png",
  },

  {
    id: "Bootstrap",
    title: "Bootstrap",
    tag: "CSS",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696355432/Portfolio%20App/icons8-bootstrap-144_1_kapdqk.png",
  },
  {
    id: "NPM",
    title: "NPM",
    tag: "Package Manager",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696355432/Portfolio%20App/icons8-npm-144_kkptgw.png",
  },
  {
    id: "CSS3",
    title: "CSS3",
    tag: "CSS",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696355434/Portfolio%20App/icons8-css3-144_yyd6sv.png",
  },
  {
    id: "JavaScript",
    title: "JavaScript",
    tag: "Language",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696355433/Portfolio%20App/icons8-javascript-144_xvzthg.png",
  },
  {
    id: "HTML5",
    title: "HTML5",
    tag: "Language",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696355434/Portfolio%20App/icons8-html-5-144_cl0rtm.png",
  },
  {
    id: "Java",
    title: "Java",
    tag: "Language",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696355435/Portfolio%20App/icons8-java-144_wgv0o2.png",
  },
  {
    id: "Python",
    title: "Python",
    tag: "Language",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696355436/Portfolio%20App/icons8-python-144_jrqvwy.png",
  },
  {
    id: "Git",
    title: "Git",
    tag: "Version Control",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696355437/Portfolio%20App/icons8-git-144_iwhgml.png",
  },
  {
    id: "Redux Toolkit",
    title: "Redux Toolkit",
    tag: "State Management",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696355439/Portfolio%20App/icons8-redux-144_jmbrhn.png",
  },

  {
    id: "React.js",
    title: "React.js",
    tag: "Library",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696264905/Portfolio%20App/React-icon_1_mn4cui.png",
  },
  {
    id: "Noded.js",
    title: "Node.js",
    tag: "Runtime Environment",
    iconUrl: "",
  },
  {
    id: "Express.js",
    title: "Express.js",
    tag: "Web Framework",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696408857/Portfolio%20App/icons8-express-js-144_cdf96o.png",
  },
  {
    id: "SQL",
    title: "SQL",
    tag: "Language",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696408857/Portfolio%20App/icons8-sql-96_frxidk.png",
  },
  // {
  //   id: "",
  //   title: "",
  //   tag: "",
  //   iconUrl: "",
  // },
];

export const apps = [
  {
    id: "Slack",
    title: "Slack",
    tag: "Communication",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696353868/Portfolio%20App/image_29_mwcjme.png",
  },
  {
    id: "Chrome",
    title: "Chrome",
    tag: "Browser",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696353921/Portfolio%20App/image_22_emidyr.png",
  },
  {
    id: "Brave",
    title: "Brave",
    tag: "Browser",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696353967/Portfolio%20App/icons8-brave-web-browser-144_hxbl8n.png",
  },
  {
    id: "ChatGPT",
    title: "ChatGPT",
    tag: "Productivity",
    iconUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696401477/Portfolio%20App/1681038242chatgpt-logo-png_1_gadtxb.png",
  },
];

export const certificatesData = [
  {
    id: "React JS",
    title: "React JS",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696783819/Portfolio%20App/Screenshot_95_zd6ptj.png",
    certificateLink:
      "https://certificates.ccbp.in/intensive/react-js?id=ZUXCTMJLIA",
  },
  {
    id: "Node JS",
    title: "Node JS",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696783819/Portfolio%20App/Screenshot_96_sxtcc1.png",
    certificateLink:
      "https://certificates.ccbp.in/intensive/node-js?id=GENZVETEZN",
  },
  {
    id: "Developer Foundations",
    title: "Developer Foundations",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696783945/Portfolio%20App/Screenshot_97_wrnvmw.png",
    certificateLink:
      "https://certificates.ccbp.in/intensive/developer-foundations?id=FDODGJSQRP",
  },
  {
    id: "Build Your Own Dynamic Web Application",
    title: "Build Your Own Dynamic Web Application",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696783863/Portfolio%20App/Screenshot_98_ba6oqr.png",
    certificateLink:
      "https://certificates.ccbp.in/intensive/dynamic-web-application?id=PKFQWNQQKU",
  },
  {
    id: "Introduction to Databases",
    title: "Introduction to Databases",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696783836/Portfolio%20App/Screenshot_99_unvhcd.png",
    certificateLink:
      "https://certificates.ccbp.in/intensive/introduction-to-databases?id=MTSQWMUAOA",
  },
  {
    id: "JavaScript Essential",
    title: "JavaScript Essentials",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696783864/Portfolio%20App/Screenshot_100_lgmspu.png",
    certificateLink:
      "https://certificates.ccbp.in/intensive/javascript-essentials?id=GOKYZIWAUS",
  },
  {
    id: "Responsive Web Design using Flexbox",
    title: "Responsive Web Design using Flexbox",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696783985/Portfolio%20App/Screenshot_101_uhp2gg.png",
    certificateLink:
      "https://certificates.ccbp.in/intensive/flexbox?id=PUWKDBDLZN",
  },
  {
    id: "Programming Foundations with Python",
    title: "Programming Foundations with Python",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696783920/Portfolio%20App/Screenshot_102_ypd206.png",
    certificateLink:
      "https://certificates.ccbp.in/intensive/programming-foundations?id=IRNZSZNSNL",
  },
  {
    id: "Build Your Own Responsive Website",
    title: "Build Your Own Responsive Website",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696783888/Portfolio%20App/Screenshot_103_afbdu5.png",
    certificateLink:
      "https://certificates.ccbp.in/intensive/responsive-website?id=OKPTYUXPSJ",
  },
  {
    id: "Build Your Own Static Website",
    title: "Build Your Own Static Website",
    imageUrl:
      "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696783897/Portfolio%20App/Screenshot_104_e4yli6.png",
    certificateLink:
      "https://certificates.ccbp.in/intensive/static-website?id=BNEPYZKXGY",
  },
];
